// extracted by mini-css-extract-plugin
export default {"ops":"Expiration_ops__12CH9","message":"Expiration_message__3Rz3e","container":"Expiration_container__3Xf1K","main":"Expiration_main__1jzct","restartBtn":"Expiration_restartBtn__26r3G","btn":"Expiration_btn__3uAER"};
    if(module.hot) {
      // 1741870133759
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  